import { ActionButton } from '@react-spectrum/s2';

import { BridgewayGlyph } from '@/components/BridgewayGlyph';

/**
 * Full-screen interstitial for Adobe accounts based in a region where Beacon
 * is not offered (anywhere outside the US and Canada). Sign out is the escape
 * hatch for someone on a shared machine whose own account is based elsewhere;
 * it also clears the cached IMS token.
 */
export const RegionBlocked = ({
	imsApi,
}: {
	imsApi: { logout: () => void };
}) => (
	<div
		className="bg-beacon-ivory flex h-full min-h-screen w-full items-center
			justify-center px-6"
		role="region"
		aria-label="Bridgeway is not available in your region"
	>
		<div className="flex max-w-md flex-col items-center gap-4 text-center">
			<BridgewayGlyph />
			<h1
				className="font-adobe-clean-display text-[28px] leading-[34px]
					font-black text-(--text-primary)"
			>
				Bridgeway isn&apos;t available in your region yet
			</h1>
			<p className="text-[16px] leading-[24px] text-(--text-secondary)">
				Bridgeway isn&apos;t offered where your Adobe account is based. Sign out
				to use a different account.
			</p>
			<ActionButton
				isQuiet
				onPress={() => imsApi.logout()}
				UNSAFE_className="btn-destructive-quiet"
			>
				Sign out
			</ActionButton>
		</div>
	</div>
);
